import {MutableRefObject, useRef} from 'react'

/**
 * A ref that always holds the value of the last render, for Leaflet handlers that are attached once but need the
 * current props.
 */
export default function useLatest<T>(value: T): MutableRefObject<T> {
    const ref = useRef(value)
    ref.current = value
    return ref
}
